/* eslint-disable no-nested-ternary */
/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-use-before-define */
import React, { useState } from 'react'
import { useForm, useFieldArray } from 'react-hook-form'
import {
  Table,
  Thead,
  Tr,
  Th,
  Td,
  Tbody,
  Button,
  Stack,
  Modal,
  CheckboxGroup,
  ButtonModal,
  ModalHeader,
  ModalBody,
  ModalOverlay,
  ModalFooter,
  ModalContent,
  useDisclosure,
} from '@chakra-ui/react'
import { Chip } from '@mui/material'
import * as UserRoles from '../../../../config/UserRoles'
import _ from 'lodash'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

export default function UserLists({ user, handleDelelte, handleUpdate }) {
  const { t } = useTranslation()
  const [isEditorMode, setIsEditorMode] = useState(false)
  const { register, handleSubmit, reset, errors, setValue, control } = useForm()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const station = useSelector((state) => state.station)
  const [selectedUser, setSelectedUser] = useState([])
  const [rerender, setRerender] = useState(false)
  const [pw, setpw] = useState(false)
  const [selectedStation, setSelectedStation] = useState([])

  const prepareUpdateDatabase = (data) => {
    const payload = {
      ...data,
      duty: selectedUser?.duty,
    }

    handleUpdate(selectedUser?._id, payload)
    setIsEditorMode(false)
    // window.location.reload()
  }

  const setSelect = (index, user) => {
    setSelectedUser(user)
    setIsEditorMode(true)
    setRerender(!rerender)
  }
  const setSelectST = (user) => {
    setSelectedStation(user)
    onOpen()
    setRerender(!rerender)
  }

  const handleCloseModal = () => {
    setSelectedStation([])
    onClose()
  }

  const genPositionOption = () => (
    <>
      <option value={UserRoles.ROLES.USER}>{'พนักงานทั่วไป ขึ้นไป'}</option>
      <option value={UserRoles.ROLES.ADMIN}>
        {'พนักงานระดับหัวหน้า ขึ้นไป'}
      </option>
      <option value={UserRoles.ROLES.MANAGER}>{'ผู้จัดการ'}</option>
      <option value={UserRoles.ROLES.SUPER_USER}>{'ผู้ดูแลระบบ'}</option>
    </>
  )
  const renderStationSelect = (userDuty) => {
    const checkNull = _.filter(userDuty, (UD, index) => UD !== null)
    return _.map(station?.arr, (_station, index) => {
      if (_station?._id === userDuty?.[index]) {
        return index < 5 ? (
          <Chip className="mx-2" size="small" label={_station?.name} />
        ) : checkNull?.length < 5 ? (
          <Chip className="mx-2" size="small" label={_station?.name} />
        ) : (
          <Chip className="mx-2" size="small" label={'...'} />
        )
      }
    })
  }

  const showDuty = () => {
    return _.map(station?.arr, (_station, index) => (
      <div
        className={`${
          _station?._id === selectedStation?.duty?.[index]
            ? 'bg-blue-400'
            : 'bg-gray-200'
        } p-2 px-4 my-2 rounded-md cursor-pointer`}
        onClick={() => {
          if (selectedStation.duty[index] === _station?._id) {
            // ลบ station ตัวนี้ออกจาก Array
            selectedStation.duty[index] = null
          } else {
            // เพิ่มลงใน Array
            selectedStation.duty[index] = _station?._id
          }
          setSelectedStation(selectedStation)
          setRerender(!rerender)
        }}
      >
        {_station?.name}
      </div>
    ))
  }

  const editorModeComponent = () => (
    <div>
      <div className="justify-self-end">
        <Button
          size="sm"
          type="button"
          colorScheme="gray"
          onClick={() => setIsEditorMode(false)}
        >
          {t('utility.cancel')}
        </Button>{' '}
        <Button size="sm" colorScheme="green" type="submit">
          {t('utility.save')}
        </Button>
      </div>
      <div className="grid sm:grid-cols-1 lg:grid-cols-5 px-5 ">
        <div className="px-5">
          <label
            className="block uppercase text-gray-700 text-sm font-bold mb-2"
            htmlFor="grid-password"
          >
            Email/Username
          </label>
          <input
            type="text"
            name="username"
            size="sm"
            defaultValue={selectedUser?.email || selectedUser?.username}
            {...register('username')}
            className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
            placeholder="example@email.com or abcd"
          />
        </div>
        <div className="mt-3 px-5">
          <label
            className="block uppercase text-gray-700 text-sm font-bold mb-2"
            htmlFor="grid-password"
          >
            {t('utility.name')}
          </label>
          <input
            name="name"
            type="text"
            defaultValue={selectedUser?.name}
            //required
            {...register('name')}
            className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
            placeholder="ชื่อ-สกุล"
          />
        </div>
        <div className="relative w-full mt-3 px-5">
          <label
            className="block uppercase text-gray-700 text-sm font-bold mb-2"
            htmlFor="grid-password"
          >
            {t('utility.tel')}
          </label>
          <input
            name="tel"
            type="text"
            defaultValue={selectedUser?.tel}
            {...register('tel')}
            className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
            placeholder="เบอร์โทรศัพท์"
          />
        </div>

        {pw ? (
          <div className="mt-3 px-5">
            <label
              className="block uppercase text-gray-700 text-sm font-bold mb-2"
              htmlFor="grid-password"
            >
              {t('connection.password')}
            </label>
            <input
              name="password"
              type="password"
              defaultValue={selectedUser?.password}
              required
              className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
              placeholder="Password"
              {...register('password')}
            />

            <label
              className="block uppercase text-gray-700 text-sm font-bold mt-2"
              htmlFor="grid-password"
            >
              {t('connection.confirmPassword')}
            </label>
            <input
              name="confirm_password"
              type="password"
              required
              className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
              placeholder="Confirm Password"
              {...register('confirm_password')}
            />
          </div>
        ) : (
          <div></div>
        )}

        <div className="grid lg:col-span-2 mt-3 px-5">
          <label
            className="block uppercase text-gray-700 text-sm font-bold mb-2"
            htmlFor="grid-password"
          >
            {t('system.address')}
          </label>
          <textarea
            name="address"
            defaultValue={selectedUser?.address}
            {...register('address')}
            rows="3"
            className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
            placeholder="ที่อยู่"
          />
        </div>
        <div className="relative w-full  mt-3 px-5">
          <label
            className="block uppercase text-gray-700 text-sm font-bold mb-2"
            htmlFor="grid-password"
          >
            {t('utility.role')}
          </label>
          <select
            onChange={(e) => {
              const data = { role: e.target.value }
              const confirm = window.confirm(
                'ยืนยันเปลี่ยนบทบาทบัญชีผู้ใช้จาก' +
                  selectedUser?.role +
                  'เป็น' +
                  e.target.value
              )
              if (confirm) handleUpdate(selectedUser?.id, data)
            }}
            defaultValue={selectedUser?.role}
            className="rounded text-md shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
          >
            {genPositionOption()}
          </select>
        </div>

        <div className="flex justify-items-center ">
          <Modal isOpen={isOpen} onClose={handleCloseModal} size={'md'}>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>
                <div className="w-full grid justify-items-center">
                  เลือกสถานีที่ต้องการดูแล
                </div>
              </ModalHeader>
              <ModalBody>
                <CheckboxGroup colorScheme="blue">
                  <Stack spacing={2} direction={'column'}>
                    {showDuty(selectedUser._id)}
                  </Stack>
                </CheckboxGroup>
              </ModalBody>
              <ModalFooter>
                <Button
                  colorScheme="red"
                  mr={3}
                  size="sm"
                  variant="solid"
                  onClick={handleCloseModal}
                >
                  {t('utility.cancel')}
                </Button>
                <Button
                  colorScheme="green"
                  size="sm"
                  onClick={() => onClose()}
                  type="button"
                >
                  {t('utility.save')}
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </div>
        <div className="grid grid-cols-3 mt-5 -mx-5">
          <Button
            variant="solid"
            size="sm"
            colorScheme="yellow"
            onClick={() => setpw(!pw)}
          >
            {' '}
            แก้ไขรหัสผ่าน{' '}
          </Button>
          <div></div>
          <Button
            variant="solid"
            size="sm"
            colorScheme="yellow"
            onClick={() => setSelectST(selectedUser)}
          >
            {' '}
            แก้ไขสถานี{' '}
          </Button>
        </div>
      </div>
    </div>
  )
  const displayModeComponent = () => (
    <div>
      <Table size="sm" variant="striped" className="whitespace-no-wrap">
        <Thead>
          <Tr>
            <Th>ลำดับที่</Th>
            <Th> {t('utility.name')}</Th>
            <Th>แผนก</Th>
            <Th></Th>
            <Th> {t('utility.role')}</Th>

            <Th> {t('utility.action')}</Th>
          </Tr>
        </Thead>
        <Tbody>{genUserLists()}</Tbody>
      </Table>
    </div>
  )

  const genUserLists = () =>
    _.map(user, (_user, index) => (
      <Tr key={_user?._id}>
        <Td>{index + 1}</Td>
        <Td>
          {_user?.name}
          {_user?.username && (
            <Chip className="mx-2" size="small" label={_user?.username} />
          )}
        </Td>
        <Td>{renderStationSelect(_user?.duty)}</Td>
        <Td></Td>
        <Td>{`${
          _user?.role === UserRoles.ROLES.USER
            ? 'พนักงานทั่วไป'
            : _user?.role === UserRoles.ROLES.ADMIN
            ? 'พนักงานระดับหัวหน้า'
            : _user?.role === UserRoles.ROLES.MANAGER
            ? 'ผู้บริหาร'
            : 'ผู้จัดการระบบ'
        }`}</Td>

        <Td className="space-x-2 center">
          <Button
            colorScheme="yellow"
            size="sm"
            onClick={() => setSelect(index, _user)}
          >
            {t('utility.edit')}
          </Button>

          <Button
            colorScheme="red"
            size="sm"
            onClick={() => {
              if (_user.role === UserRoles.ROLES.SUPER_USER) {
                alert('ไม่สามารถลบบัญชี SUPERUSER')
              } else {
                const confirm = window.confirm('ยืนยันการลบบัญชีผู้ใช้')
                if (confirm) handleDelelte(_user.id)
              }
            }}
          >
            {t('utility.delete')}
          </Button>
        </Td>
      </Tr>
    ))

  return (
    <div>
      <form onSubmit={handleSubmit(prepareUpdateDatabase)}>
        <div>
          {isEditorMode === true
            ? editorModeComponent()
            : displayModeComponent()}
        </div>
      </form>
    </div>
  )
}
